import script from "./monthly-compliance-report.vue?vue&type=script&setup=true&lang=js"
export * from "./monthly-compliance-report.vue?vue&type=script&setup=true&lang=js"

import "./monthly-compliance-report.vue?vue&type=style&index=0&id=cc8e096e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8e096e"]])

export default __exports__